import { APIEndpoints } from "@/data/constants/endpoints";
import { ProgressCallback, Request } from "@/data/api/utils/network";
import { RequestParams } from "@/data/types";
import { TFileItem, TFilePayload } from "@/data/types";

/**
 * Get all files with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllFiles = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.FILES.BASE,
    type: "GET",
    params,
  });
};

/**
 * Create a new file
 * @param params Request parameters
 * @param payload Create payload
 */
export const createFile = (
  params: RequestParams,
  payload: TFilePayload,
  onProgress?: ProgressCallback
) => {
  return Request({
    path: APIEndpoints.FILES.CREATE,
    type: "POST",
    params,
    body: payload,
    onProgress: onProgress,
    contentType: "multipart/form-data",
  });
};

/**
 * Get a file by ID
 * @param fileId The ID of the file to retrieve
 * @param params Request parameters
 */
export const getFileById = (fileId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.FILES.BY_ID(fileId),
    type: "GET",
    params,
  });
};

/**
 * Update a file by ID
 * @param fileId The ID of the file to update
 * @param params Request parameters
 * @param payload Update payload
 */
export const updateFile = (
  fileId: string,
  params: RequestParams,
  payload: Partial<TFilePayload>
) => {
  return Request({
    path: APIEndpoints.FILES.BY_ID(fileId),
    type: "PATCH",
    params,
    body: payload,
  });
};

/**
 * Delete a file by ID
 * @param fileId The ID of the file to delete
 * @param params Request parameters
 */
export const deleteFile = (fileId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.FILES.BY_ID(fileId),
    type: "DELETE",
    params,
  });
};
